import React from 'react';
import useFormattedDate from '../../hooks/useFormattedDate';

export default function FormattedDate({ date }) {
  const formattedDate = useFormattedDate(date);
  return <>{formattedDate}</>;
}
